// extracted by css-extract-rspack-plugin
export default {"playButtonWrapper":"playButton-module__playButtonWrapper___xngtN","playButton":"playButton-module__playButton___BV8Jw"};